class VimeoControls extends HTMLElement {
  constructor() {
      super();
      this.initPlayer();

  };

  initPlayer() {
    const iframes = this.querySelectorAll('iframe');

    // Find the active frame (desktop or mobile)
    this.iframe = Array.from(iframes).find(function(iframe) {
      return window.getComputedStyle(iframe).display !== 'none';
    });  

    const VimeoControls = this;
    var interval = setInterval(function() {
      // Check if Vimeo API is defined
      if (typeof Vimeo !== 'undefined') {
        clearInterval(interval);
        VimeoControls.player = new Vimeo.Player(VimeoControls.iframe);
        VimeoControls.button = VimeoControls.querySelector('.vimeo-play-pause-button');
        VimeoControls.playIcon = VimeoControls.querySelector('.vimeo-play-icon');
        VimeoControls.pauseIcon = VimeoControls.querySelector('.vimeo-pause-icon');

        VimeoControls.initEvents();
      }
    }, 100);
  }

  initEvents() {
    const VimeoControls = this;
    this.button.addEventListener('click', function() {
      VimeoControls.player.getPaused().then(function(paused) {
        if (paused) {
          VimeoControls.player.play();
          VimeoControls.pauseIcon.style.display = "block";
          VimeoControls.playIcon.style.display = "none";
        } else {
          VimeoControls.player.pause();
          VimeoControls.playIcon.style.display = "block";
          VimeoControls.pauseIcon.style.display = "none";
        }
      });
    });
  }

  
}

customElements.define('vimeo-controls', VimeoControls);